module.exports = __webpack_public_path__ + "images/tour/create.e8f8231485d1a497ab0d.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tour/create.svg
// module id = aIwn
// module chunks = 1